module.exports = __webpack_public_path__ + "img/Life-Insurance-Guide_Products_Perm-Life-Icon.4a02e645.svg";